var map = {
	"./demos/basic/index.ts": 65726,
	"./demos/citations/index.ts": 36332,
	"./demos/codeBlockRenderers/index.ts": 78625,
	"./demos/formula/index.ts": 68654,
	"./demos/html/index.ts": 96861,
	"./demos/mermaid/index.ts": 66963,
	"./demos/plugins/index.ts": 35263,
	"./demos/streamingRich/index.ts": 31774,
	"./demos/tagRenderers/index.ts": 3208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70423;